import { random } from 'app/utils'

export const randomEmoji = (type: 'angry' | 'happy'): string => {
	var emojiList: string[] = []
	if (type === "angry") emojiList = ["(≥o≤)", "(·_·)", "(O_O)", "(^Д^)", "(;-;)", "T_T", "(>_<)", "(˚Δ˚)", "(╯°□°)╯", "(˚Õ˚)", "(ﾉ･д･)ﾉ", "¯\\_(ツ)_/¯"]
	if (type === "happy") emojiList = ["(*^▽^*)", "⊂((・▽・))⊃", "ᕕ( ᐛ )ᕗ", "(・∀・)", "(˘･ᴗ･˘)", "＼（＾▽＾）／", "୧(﹒︠ᴗ﹒︡)୨", "╰( ･ ᗜ ･ )╯", "(⌐■_■)"]
	return random(emojiList)
}